import { Component, OnInit, HostBinding, isDevMode } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Utils } from '../../utils';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { OrderRs, CancelRs } from '../../interfaces/service.response';
import { ShareService, ShareProvider } from '../../services/share.service';

export class OrderNotificationParams {
    constructor (
        public responseData: OrderRs | CancelRs
    ) { }
}
@Component( {
    selector: '[order-notification]',
    template: require('./order-notification.component.html'),
    styles: [ require('./order-notification.component.css') ],
    animations: [
        trigger( 'flyInOut', [
            state( 'inactive', style( {

                opacity: 0
            } ) ),
            state( 'active', style( { opacity: 100 } ) ),
            state( 'removed', style( { opacity: 0 } ) ),
            transition( 'inactive => active', animate( '{{ easeTime }}ms {{ easing }}' ) ),
            transition( 'active => removed', animate( '{{ easeTime }}ms {{ easing }}' ) )
        ] ) ],
    preserveWhitespaces: false,
} )
export class OrderNotificationComponent extends Toast implements OnInit {
    params: OrderNotificationParams;
    public ticketToCancel?: string;
    private _tradeData: OrderRs | CancelRs = new OrderRs() || new CancelRs();

    set responseData ( v: OrderRs | CancelRs ) {
        if ( v.Currency === undefined || v.OK === false ) {

            this.hideAllItems = true;
        }
        this._tradeData = v;
    }

    get responseData (): OrderRs | CancelRs {
        return this._tradeData
    }


    private _hideAllItems: boolean = false;
    public get hideAllItems (): boolean {
        return this._hideAllItems;
    }
    public set hideAllItems ( value: boolean ) {
        this._hideAllItems = value;
    }


    get Type (): string {

        return this.responseData.Type;
    };
    get Currency (): string { return this.responseData.Currency };
    get Quantity (): number { return this.responseData.Quantity };
    get Side (): string { return this.responseData.Side };
    get StopPrice (): number { return this.responseData.StopPrice };
    get LimitPrice (): number { return this.responseData.LimitPrice };
    get Error (): string {

        return this.responseData.Error
    };

    @HostBinding( 'class.error' )
    get ErrorNotEmpty () {
        return this.Error != null && this.Error != '';
    }

    set Type ( v: string ) { };
    set Currency ( v: string ) { };
    set Quantity ( v: number ) { };
    set Side ( v: string ) { };
    set LimitPrice ( v: number ) { };
    set StopPrice ( v: number ) { };
    set Error ( v: string ) { };
    constructor ( protected toastrService: ToastrService, public toastPackage: ToastPackage, public shareService: ShareService ) {
        super( toastrService, toastPackage );
        this.params = JSON.parse( Utils.decodeHTMLEntities( this.message as string ) );
        this.responseData = this.params.responseData;
    }

    ngOnInit () {
    }

    public share ( provider: string ) {
        this.shareService.shareWithSvg( provider, this.getShareText() );
    }

    getShareText () {
        let orderRs = this.responseData as OrderRs;
        if ( orderRs == null )
            return '';

        return Math.random() < 0.5 ?
            'Going ' + ( orderRs.Side == 'Sell' ? 'SHORT' : 'LONG' ) + ' on the (' + this.Currency + ') NOW using PremiereTrade .  Check it out !!! #PremiereTrade #Forex #ForexTrading' :
            'Just went ' + ( orderRs.Side == 'Sell' ? 'SHORT' : 'LONG' ) + ' on the (' + this.Currency + ').. Follow me using PremiereTrade. Check it out !!! #PremiereTrade #Forex #ForexTrading';
    }

}


